import { MatchedAudience } from '../edgekit';
import { timeStampInSecs } from './timestamp';

export const makeServerSideMatchedAudiences = (
  serverSideMatchedAudiences: { id: string; ttl: number }[],
  previousMatchedAudiences: MatchedAudience[]
): MatchedAudience[] => {
  const now = timeStampInSecs();

  const previousMatchedAudienceMap = previousMatchedAudiences.reduce<
    Record<string, MatchedAudience>
  >((acc, matchedAudience) => {
    acc[matchedAudience.id] = matchedAudience;
    return acc;
  }, {});

  const matchedAudiences: MatchedAudience[] = serverSideMatchedAudiences.map(
    (audience) => {
      const matchedAudience = {
        id: audience.id,
        version: 0,
        matchedAt: now,
        expiresAt: now + audience.ttl,
        matchedOnCurrentPageView: true,
      };

      const previousMatchedAudience = previousMatchedAudienceMap[audience.id];
      if (previousMatchedAudience) {
        matchedAudience.version = previousMatchedAudience.version;
        matchedAudience.matchedAt = previousMatchedAudience.matchedAt;
        matchedAudience.expiresAt =
          previousMatchedAudience.matchedAt + audience.ttl;
        matchedAudience.matchedOnCurrentPageView =
          previousMatchedAudience.matchedOnCurrentPageView;
      }

      return matchedAudience;
    }
  );

  return matchedAudiences;
};
